import { render, staticRenderFns } from "./PAVView.vue?vue&type=template&id=873db306&scoped=true"
import script from "./PAVView.vue?vue&type=script&lang=js"
export * from "./PAVView.vue?vue&type=script&lang=js"
import style0 from "./PAVView.vue?vue&type=style&index=0&id=873db306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873db306",
  null
  
)

export default component.exports